import React from "react";

const MenuChucNang = ({ RoleThemMoiCauHinhTaiSan,btnThemMoiCauHinhTaiSanClick }) => (
    <div className="search-new" >
        <div className="input-sm-new" onClick={btnThemMoiCauHinhTaiSanClick} style={{ width: "12%", display: RoleThemMoiCauHinhTaiSan ? "block" : "none", }}>
            <button className="btn btn-border-new" ><img src="/app-assets/images/icon-them-moi-cam-do.png" class="icon-button-v2" /><span style={{ color: "" }}>Thêm mới</span></button>
        </div>
    </div>
);

export default MenuChucNang;